const header = document.querySelector("header.header");
const headerHeight = header.clientHeight;
const bannerHeight = document.getElementById("MainContent").clientHeight;
const sectionHeader = document.querySelector(".section-header");
document.addEventListener("scroll", (e) => {
  const y = window.scrollY;

  if (y > headerHeight) {
    sectionHeader.classList.add("offsetY");
  } else {
    sectionHeader.classList.remove("offsetY");
  }

  if (y < bannerHeight / 2) {
    sectionHeader.classList.add("absolute");
    sectionHeader.classList.remove("active");
  } else {
    sectionHeader.classList.remove("absolute");
    sectionHeader.classList.add("active");
    sectionHeader.classList.remove("offsetY");
  }
});
